import { IMyOptions, IMyDateModel } from 'mydatepicker';
import * as moment from 'moment';

export let config: IMyOptions = {
	editableDateField: true,
	openSelectorOnInputClick: true,
	showClearDateBtn: true,
	dateFormat: 'yyyy-mm-dd'
}

export let toString = (data: IMyDateModel) => data.formatted;
export let toObject = (date: string) => {
	if(!date)
		return null;

	let _date = moment(date);
	return {
		date: {
			year: _date.year(),
			month: _date.month() + 1,
			day: _date.date()
		},
		formatted: _date.format('YYYY-MM-DD')
	};
};


// WEBPACK FOOTER //
// ./src/config/datepicker.config.ts